import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from 'antd'
import styles from './index.module.scss'
import MainContext from '@/stores/stores'
import llq1Png from '@/assets/img/llq1.png'
import llq2Png from '@/assets/img/llq2.png'
import { useIntl } from 'react-intl'

const FooterThree: React.FC<any> = (props) => {
  const { info } = props
  const [config, setConfig] = useState<any>(info.config ? info.config : {})
  const intl = useIntl()
  let lang = localStorage.getItem('lang') || 'zh'
  const navigate = useNavigate()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, pageType, isWomala, webData, colorPrimary, logo, fontColorPrimary  } = commonStore

  useEffect(() => {
    setTimeout(() => {
      props.onReady?.()
    },100)
  },[pageType])
  const cexport = () => {
    const origin = window.location.origin || ''
    const allowed = [
      'kangpower.maiqipei.com',
      'www.kangpower.com'
    ]
    const originMatches = allowed.some((s) => origin.includes(s))
    if (originMatches) return true
    if (origin.includes('webtest.maiqipei.com') || origin.includes('300')) return true
    return false
  }
  let otherPage  = pageType === '3' || isWomala ? true : false

  const goto = (url: string) => {
    if(url) {
      window.open(url, "_blank")
    }
  }
  const toHome = () => {
    navigate('/home')
  }
  const toMoreLink = (item: any) => {
    if(item.need_login && (!localStorage.getItem('token') || localStorage.getItem("tourist_user"))) {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
      return false
    }
    let url = item.url
    navigate(url)
  }
  return (
    <div 
      id="footer"
      className={styles['footer2']} 
      style={{ backgroundColor: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}
    >
      <div className={styles['footer-wrap']}>
        <div className={styles['footer-lf']} style={{ borderRight: '1.5px solid rgba(153, 153, 153, 0.2)' }}>
          <div className={styles['footer-logo-wrap']}>
            <div>
              <img src={config.logo ? config.logo : logo} className={styles['footer-logo']} alt="" onClick={toHome} />
              {
                config.other_img ? <img style={{marginTop: 10}} src={config.other_img} alt="" className={styles['footer-logo']}  onClick={() => goto(config.other_url ? config.other_url : '')}  /> : null
              }
            </div>
            {
              config.more_link && config.more_link.length ? null : <div className={styles['vertical']}></div>
            }
          </div>
        </div>
        <div className={styles['footer-rt']} style={{ width: 'calc(100% - 160px)' }}>
          {
            config.more_link && config.more_link.length ? <div className={styles['more-links']}>
              {
                config.more_link.map((items: any, index: number) => {
                  return (
                    <div className={styles['more-link']} key={index} style={{maxWidth: (100/config.more_link.length).toFixed(0) + '%'}}>
                      {
                        items.title ? <div className={styles['link-title']} style={{textAlign: config.more_link.length > 1 ? (items.align ? items.align : 'left') : 'left', color: fontColorPrimary}}><pre>{items.title}</pre></div> : null
                      }
                      {
                        items.links && items.links.length ? <div className={config.more_link.length === 1 ? styles['link-list'] + ' flex-s-c flex-wrap' : styles['link-list']}>
                          {
                            items.links.map((item: any, n: number) => {
                              return (
                                <div 
                                  className={styles['link-item']} 
                                  key={n}
                                  style={{width: config.more_link.length === 1 ? '33%' : '100%', textAlign: config.more_link.length > 1 ? (items.align ? items.align : 'left') : 'left', color: fontColorPrimary}} 
                                  onClick={() => toMoreLink(item)}
                                >
                                  {item.name}
                                </div>
                              )
                            })
                          }
                        </div> : null
                      }
                    </div>
                  )
                })
              }
            </div> : null
          }
          <div className={styles['footer-company']}>
            <div className={styles['footer-rt-l']}>
              <img src={config.qrcode} alt="" style={{ width: config.qrcode_width, height: config.qrcode_height, marginRight: 10 }} />
              {
                config.phone ? <div className={styles['footer-item']} style={{marginRight: lang === 'ara' ? 0 : 40, marginLeft: lang === 'ara' ? 40 : 0, height: '55px', justifyContent: 'center'}}>
                  <div>
                    <i className="iconfont icon-a-24gf-telephone1 mr5" />
                    {config.phone}
                  </div>
                </div> : null
              }
              {
                config.email ? <div className={styles['footer-item']} style={{height: '55px', justifyContent: 'center'}}>
                  <div>
                    <i className="iconfont icon-a-youxiang11 mr5" />
                    {config.email} 
                  </div>
                </div> : null
              }
            </div>
            <div className={styles['footer-item3']}>
              {
                commonStore.supportData && commonStore.supportData.show_technical_support ? <>
                  <div style={{ cursor: 'pointer'  }}  onClick={() => goto('https://www.maiqipei.com/')}>{intl.formatMessage({id: '此网站由零零汽提供技术支持'})}</div>
                  <span className="ml10 mr10">|</span>
                </> : null
              }
              <div style={{ cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{config.filings_no}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FooterThree